export default {
  name: 'staff_manage',
  path: 'staff_manage',
  component: () => import(/* webpackChunkName: "pos" */ './list.vue')
}
